import {Router} from 'express';

/* eslint-disable new-cap */
let router = Router();
/* eslint-enable new-cap */

import contactUsController from '../controllers/ContactUsController';

const contact = new contactUsController();

router.get('/', contact.index);

router.post('/', contact.contactUs);

router.post('/demo', contact.demoContactUs);

router.post('/subscribe-newsletter', contact.subscribeNewsletter);

export default router;
